import { Badge, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { CUSTOM_EVENTS } from '../../../../utils/constants';
import useMedicineStore from '../../../../zustandstores/medicinecart.store';
import ConfirmOrder from './confirm-order.component';

const CartBtn = () => {
    const {cart} = useSelector(state => state.cart);
    const {cart: medCart} = useMedicineStore();
    const [toggleCart, setToggleCart] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const toggleDrawer = () => {
        setToggleCart(!toggleCart);
    };

    // const showCart = () => navigate('/cart');

    useEffect(() => {
        const controller = new AbortController();
        const openCart = () => { setToggleCart(true); };
        document.addEventListener(CUSTOM_EVENTS.SHOW_CART, openCart, { signal: controller.signal });

        return () => {
            controller.abort();
        };
    }, []);

    const cartDrawer = (
        <>
            <Drawer
                anchor="right"
                open={toggleCart}
                onClose={toggleDrawer}
            >
                <ConfirmOrder closeCart={toggleDrawer} />
            </Drawer>
        </>
    );

    const cartUI = () => {
        const totalCartItems = cart.length + medCart.length;
        if (isMobile) {
            return (
                <Badge badgeContent={totalCartItems} color="primary">
                    <Typography onClick={toggleDrawer} variant='body1'>Cart</Typography>
                </Badge>
            );
        }

        return (
            <IconButton aria-label="shopping_cart" className='btn-square cart-btn' onClick={toggleDrawer}>
                <Badge badgeContent={totalCartItems} color="primary">
                    <ShoppingCartIcon />
                </Badge>
            </IconButton>
        );
    };
    return (
        <>
            {cartUI()}
            {cartDrawer}
        </>
    );
};

export default CartBtn;